export default function BubbleHoverEffect(element, event, isPopupAnim=false){
    let { offsetX, offsetY } = event;
    let width = element.offsetWidth;
    let height = element.offsetHeight;
    if(isPopupAnim){
        width = window.innerWidth;
        height = window.innerHeight;
    }
    const xPercent = (offsetX / width) * 100;
    const yPercent = (offsetY / height) * 100;

    const xStyleProp = '--_xValue-self';
    const yStyleProp = '--_yValue-self';
    const bgPerc = '--_box-bg-perc';
    element.style.setProperty(bgPerc, '150%');

    element.style.setProperty(xStyleProp, xPercent);
    element.style.setProperty(yStyleProp, yPercent);
}